export default {
  CUSTOMER_USER: {
    name: 'customer',
  },
};
